<template lang="pug">
div
  h1.h3.u-mb-sm.u-lineHeight Checkbox

  CodeSample(name="Default" :pug="defaultPug" :html="defaultHtml" )
    label.checkbox
      input.checkbox-input(type='checkbox')
      span.checkbox-label Checkbox label



  CodeSample(name="Sizes" :pug="sizesPug" :html="sizesHtml" class="u-mt-md")
    label.checkbox.is-tiny
      input.checkbox-input(type='checkbox')
      span.checkbox-label is-tiny
    label.checkbox.is-small
      input.checkbox-input(type='checkbox')
      span.checkbox-label is-small
    label.checkbox.is-normal
      input.checkbox-input(type='checkbox')
      span.checkbox-label is-normal
    label.checkbox.is-large
      input.checkbox-input(type='checkbox')
      span.checkbox-label is-large
    label.checkbox.is-massive
      input.checkbox-input(type='checkbox')
      span.checkbox-label is-massive

  CodeSample(name="Inline" :pug="inlinePug" :html="inlineHtml" class="u-mt-md")
    label.checkbox.is-inline
      input.checkbox-input(type='checkbox')
      span.checkbox-label is-inline
    label.checkbox.is-inline
      input.checkbox-input(type='checkbox')
      span.checkbox-label is-inline
    label.checkbox.is-inline
      input.checkbox-input(type='checkbox')
      span.checkbox-label is-inline
    label.checkbox.is-inline
      input.checkbox-input(type='checkbox')
      span.checkbox-label is-inline



  CodeSample(name="Disabled" :pug="disabledPug" :html="disabledHtml" class="u-mt-md")
    label.checkbox.is-disabled
      input.checkbox-input(type='checkbox' )
      span.checkbox-label Checkbox label



  table.table.is-relaxed.u-mt-md
    thead
      tr
        th Modifier
        th Description
        th Class
    tbody

      tr
        td Size
        td changes the element size based on font-size
        td
          p .is-tiny
          p .is-small
          p .is-normal
          p .is-large
          p .is-massive
      tr
        td inline
        td make checkbox inline
        td .is-inline
      tr
        td Disabled
        td indicates that a checkbox is disabled, equivalent to `checkbox[disabled]`
        td .is-disabled

</template>

<script>
import CodeSample from '~/components/CodeSample';

export default {
  scrollToTop: true,
  layout: 'base',
  head: () => ({
    title: 'Checkbox'
  }),
  components: {
    CodeSample
  },
  data: () => ({
    defaultPug: `label.checkbox
  input.checkbox-input(type='checkbox')
  span.checkbox-label Checkbox label`,
    defaultHtml: `<label class="checkbox">
  <input type="checkbox" class="checkbox-input"/><span class="checkbox-label">Checkbox label</span>
</label>`,
    sizesPug: `label.checkbox.is-tiny
  input.checkbox-input(type='checkbox')
  span.checkbox-label is-tiny
label.checkbox.is-small
  input.checkbox-input(type='checkbox')
  span.checkbox-label is-small
label.checkbox.is-normal
  input.checkbox-input(type='checkbox')
  span.checkbox-label is-normal
label.checkbox.is-large
  input.checkbox-input(type='checkbox')
  span.checkbox-label is-large
label.checkbox.is-massive
  input.checkbox-input(type='checkbox')
  span.checkbox-label is-massive`,
    sizesHtml: `<label class="checkbox is-tiny">
  <input type="checkbox" class="checkbox-input"/><span class="checkbox-label">is-tiny</span>
</label>
<label class="checkbox is-small">
  <input type="checkbox" class="checkbox-input"/><span class="checkbox-label">is-small</span>
</label>
<label class="checkbox is-normal">
  <input type="checkbox" class="checkbox-input"/><span class="checkbox-label">is-normal</span>
</label>
<label class="checkbox is-large">
  <input type="checkbox" class="checkbox-input"/><span class="checkbox-label">is-large</span>
</label>
<label class="checkbox is-massive">
  <input type="checkbox" class="checkbox-input"/><span class="checkbox-label">is-massive</span>
</label>`,
    inlinePug: `label.checkbox.is-inline
  input.checkbox-input(type='checkbox')
  span.checkbox-label is-inline
label.checkbox.is-inline
  input.checkbox-input(type='checkbox')
  span.checkbox-label is-inline
label.checkbox.is-inline
  input.checkbox-input(type='checkbox')
  span.checkbox-label is-inline
label.checkbox.is-inline
  input.checkbox-input(type='checkbox')
  span.checkbox-label is-inline`,
    inlineHtml: `<label class="checkbox is-inline">
  <input type="checkbox" class="checkbox-input"/><span class="checkbox-label">is-inline</span>
</label>
<label class="checkbox is-inline">
  <input type="checkbox" class="checkbox-input"/><span class="checkbox-label">is-inline</span>
</label>
<label class="checkbox is-inline">
  <input type="checkbox" class="checkbox-input"/><span class="checkbox-label">is-inline</span>
</label>
<label class="checkbox is-inline">
  <input type="checkbox" class="checkbox-input"/><span class="checkbox-label">is-inline</span>
</label>`,
    disabledPug: 'input.input.is-disabled(value="is-disabled", type="text", disabled)',
    disabledHtml: '<input value="is-disabled" type="text" disabled="disabled" class="input is-disabled"/>'
  })
};
</script>
